import React, { useEffect } from 'react'
import { Button } from 'components'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { STATICS } from 'statics'
import { setDrawer } from 'slices/drawer'
import { useFirebaseEvent } from 'hooks'
import { useDispatch } from 'react-redux'
import './style.scss'

export function InvoicesError() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.FUNCTION_CALLING_GET_INVOICES)
  }, [sendEvent])

  function handleClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-integration-error'>
      <div className='container-info'>
        <div className='container-icon'>
          <STATICS.INFO_ERROR_FAQ />
        </div>
        <span className='title'>
          Ops! <br />
          Não foi possível concluir a busca
        </span>
        <span className='description'>Por favor, aguarde alguns minutos e tente novamente.</span>
      </div>
      <div className='container-buttons'>
        <Button onClick={handleClose} className='button accept' color='primary'>
          ok, entendi
        </Button>
      </div>
    </div>
  )
}
